import type { StationWriteRequest } from '@/api/generated/schemas';
import type { StationFormValues } from './stationFormSchema';

function emptyToNull(value: string): string | null {
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

/**
 * Mapuje hodnoty formuláře na API tělo zápisu stanice. Pořadí `stationDetails` je významné — BE
 * z indexu odvodí `Ord`. Vlastní souřadnice stanice se posílají jen když nemá žádné místo (§6).
 */
export function toStationRequestBody(values: StationFormValues): StationWriteRequest {
  const hasPlaces = values.stationDetails.length > 0;
  return {
    name: values.name.trim(),
    code: emptyToNull(values.code),
    stationTypeCbId: values.stationType?.id ?? 0,
    destinationId: values.destination?.destinationId ?? null,
    isDomestic: values.isDomestic,
    timeZoneOffset: values.timeZoneOffset,
    stationLatitude: hasPlaces ? null : values.stationLatitude,
    stationLongitude: hasPlaces ? null : values.stationLongitude,
    stationZoom: hasPlaces ? null : values.stationZoom,
    stationDetails: values.stationDetails.map((detail) => ({
      id: detail.id,
      description: detail.description.trim(),
      street: emptyToNull(detail.street),
      descriptiveNumber: emptyToNull(detail.descriptiveNumber),
      orientationNumber: emptyToNull(detail.orientationNumber),
      poBox: emptyToNull(detail.poBox),
      city: emptyToNull(detail.city),
      zipCode: emptyToNull(detail.zipCode),
      countryId: detail.country?.countryId ?? null,
      latitude: detail.latitude,
      longitude: detail.longitude,
      zoom: detail.zoom,
    })),
  } satisfies StationWriteRequest;
}
